import { render } from "./UiPanel.vue?vue&type=template&id=18d05c60&ts=true"
import script from "./UiPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiPanel.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18d05c60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18d05c60', __exports__)) {
    api.reload('18d05c60', __exports__)
  }
  
  module.hot.accept("./UiPanel.vue?vue&type=template&id=18d05c60&ts=true", () => {
    api.rerender('18d05c60', render)
  })

}


export default __exports__